import {ActivatedRoute,} from '@angular/router';
import {Component, OnInit,} from '@angular/core';
import {MessageLevel,} from '@models/index';
import {Logger,
        LoginInfoService,
        MessageStackService,
        SmsMenuPage,
        SmsErrorPage,
        ValidationService,
        SystemConstant,
        WindowService,} from '@services/index';
import {isEmpty,} from 'lodash';

@Component({
  selector: 'app-sms000-main',
  templateUrl: './sms000-main.html',
  styleUrls: ['./sms000-main.scss',],
})
/*****************************************************/
/* 処　理：SMS000 接続メイン
/*
/* 概　要：接続メイン処理
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS000Main implements OnInit {
  // GETパラメータ
  id!: string;  // 契約情報ID（ハッシュ値）
  no!: string;  // 取引メニュー番号

  /**
   *  デフォルトコンストラクタ
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private constant: SystemConstant,
    private logger: Logger,
    private windowService: WindowService,
    private loginInfoService: LoginInfoService,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public validationService: ValidationService
  ) {}

  /**
   *  初期処理(ngOnInit).
   */
  ngOnInit(): void {
    // 認証処理
    this.authInit();
  }

  /**
   * 認証処理
   */
  authInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00001M001I');

      // ロールストレージの初期化
      this.loginInfoService.clear();

      // GET-パラメータ取得
      const queryParams = this._activatedRoute.snapshot.queryParams;
      this.id = queryParams.id;   // 契約情報ID（ハッシュ値）
      this.no = queryParams.no;   // 取引メニュー番号

      // ログ出力（GETパラメータ）
      this.logger.info('SMS00001M003I', this.id);
      this.logger.info('SMS00001M004I', this.no);

      // 入力チェック
      if (!this.inputCheck()) {
        this.logger.error('SMS00001M002E');

        // エラー画面に遷移
        const messageStack = new MessageStackService(MessageLevel.ERROR);
        messageStack.add({messageId: 'SMS99901M013E',});
        this.transitErrPage(messageStack);
        return;
      }

      // パラメータ情報取得成功
      this.logger.info('SMS00001M002I');
      // 画面遷移
      this.nextPage();

      // ログ出力
      this.logger.info('SMS00001M005I');

    } catch (err) {

      // エラーログ出力
      this.logger.error('SMS00001M001E', [this.id,]);
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err);

      // エラー画面に遷移
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.transitErrPage(messageStack);

      return;
    }

  }

  /**
   * 入力チェック
   * @returns エラーメッセージID
   */
  inputCheck(): boolean {
    let isRet = true;

    this.logger.debug('■ 00 入力チェック開始');

    // 契約情報ID（ハッシュ値）チェック
    if (!isEmpty(this.id) && this.id.length === 64) {
      this.logger.debug('■ 00 契約情報ID（ハッシュ値）：OK');

    } else {
      this.logger.debug('■ 00 契約情報ID（ハッシュ値）：NG');
      this.logger.error('SMS00001M003E');
      isRet = false;
    }

    // 許可済み取引メニュー番号一覧に存在するか
    const menuNo = this.constant.ARRAY_PERMITTED_MENU_NO.find(item => item === this.no)

    // 取引メニュー番号チェック
    if (!isEmpty(menuNo)) {
      this.logger.debug('■ 00 取引メニュー番号：OK');

    } else {
      this.logger.debug('■ 00 取引メニュー番号：NG');
      this.logger.error('SMS00001M004E');
      isRet = false;
    }

    this.logger.debug('■ 00 入力チェック終了');

    return isRet;
  }

  /**
   * 画面遷移
   */
  nextPage(): void{

    // SMS001：メインメニュー画面に遷移
    this.smsMenuPage.transition(this.id,                               // 契約情報ID（ハッシュ値）
                                this.no,                               // 取引メニュー番号
                                this.constant.DEFAULT_LANGUAGE_TYPE);  // 言語区分（初期値：日本語）

  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               '',
                               '',
                               this.constant.DEFAULT_LANGUAGE_TYPE);  // 言語区分（初期値：日本語）
  }
}
